import api from './api';

export const getActivityLog = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const response = await api.get(`/activity-logs?${queryParams}`);
  return response.data;
};
